
import { AboutUs } from '../components/AboutUs';

export function AboutUsPage() {
    return (
        <div className="min-h-screen">
            {/* About Us Section */}
            <div className="pt-20">
                <AboutUs />
            </div>
        </div>
    );
}
